/** @file Times, values and curve codes of a curved channel (numeric levels or 0..1 progress). */
import type { Curve } from '@pose2d/format/types';
import type { CurveCode } from './compileCurve';
import { segmentCurves } from './segmentCurves';
import { sortKeysByFrame } from './sortKeysByFrame';

/** `t` in seconds (f / fps), values verbatim; `level` null = progress-form curves; `c` omitted when all linear. */
export function curvedTimeline<V>(keys: readonly { f: number; v: V; curve?: Curve | undefined }[], fps: number, level: ((v: V) => number) | null): { t: number[]; v: V[]; c?: CurveCode[] } {
  const sorted = sortKeysByFrame(keys);
  const v = sorted.map((k) => k.v);
  const c = segmentCurves(sorted, level === null ? null : v.map(level));
  return { t: sorted.map((k) => k.f / fps), v, ...(c === null ? {} : { c }) };
}
